import { useMemo } from 'react'
import { useListThreatProfilesQuery, useGetThreatProfileQuery } from './profiles'
import { useSelectedThreatProfileStorage } from './useSelectedThreatProfileStorage'
import { useThreatProfilesTokenClaims } from './useThreatProfilesTokenClaims'

export const useSelectedThreatProfileQuery = (options = {}) => {
  const claims = useThreatProfilesTokenClaims()
  const isGTI = Array.isArray(claims.isl) && claims.isl.some(item => item.toLowerCase().includes('gti'))

  const { data: listData, isLoading: listIsLoading } = useListThreatProfilesQuery({ ...(!isGTI && { filter: 'is_shared = false' }) })
  const [storedId, setStoredId] = useSelectedThreatProfileStorage()

  const selectedId = useMemo(() => {
    if (!listData?.profiles?.length) {
      return
    }
    // storedId is available for this user. If so, return it.
    if (storedId) {
      return storedId
    }
    // If not, return the first accessible profile name if it exists
    return listData.profiles[0].name
  }, [listData, storedId])

  const unavailable = !listIsLoading && !selectedId
  const profileResponse = useGetThreatProfileQuery(selectedId, options)

  if (unavailable) {
    return { data: null, isLoading: false }
  }

  const { isError } = profileResponse

  if (isError && storedId) {
    // set the first accessible profile name as the storedId since the stored one is invalid
    setStoredId(listData.profiles[0].name)
  }

  return profileResponse
}
